export const PLANS_RECEIVED = 'PLANS_RECEIVED'
export const PLANS_SAVED = "PLANS_SAVED"
